import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, Sparkles, ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { getSpotlightStatus } from '@/lib/api';

const SpotlightSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (sessionId) {
      const check = async () => {
        try {
          const res = await getSpotlightStatus(sessionId);
          setStatus(res.data);
        } catch (e) {
          console.error(e);
        } finally {
          setLoading(false);
        }
      };
      check();
    } else {
      setLoading(false);
    }
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <section className="pt-32 pb-20">
        <div className="max-w-lg mx-auto px-4">
          <Card className="shadow-lg" data-testid="spotlight-success-card">
            <CardContent className="p-10 text-center">
              {loading ? (
                <Loader2 className="h-12 w-12 animate-spin text-teal-500 mx-auto" />
              ) : status?.payment_status === 'paid' ? (
                <>
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <CheckCircle className="h-8 w-8 text-teal-600" />
                  </div>
                  <h1 className="font-heading text-2xl font-bold text-slate-900 mb-2">Event Submitted!</h1>
                  <p className="text-slate-600 mb-6">
                    Your event spotlight has been paid and activated. It will appear at the top of the Events page for 30 days and be promoted across Paisley.org.uk and social media.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <Link to="/events">
                      <Button className="bg-teal-600 hover:bg-teal-700">
                        View Events <ArrowRight className="h-4 w-4 ml-2" />
                      </Button>
                    </Link>
                    <Link to="/">
                      <Button variant="outline">Back to Home</Button>
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <Sparkles className="h-8 w-8 text-amber-600" />
                  </div>
                  <h1 className="font-heading text-2xl font-bold text-slate-900 mb-2">Processing Payment</h1>
                  <p className="text-slate-600 mb-6">
                    Your payment is being processed. Your event will be activated shortly.
                  </p>
                  <Link to="/events">
                    <Button variant="outline">View Events</Button>
                  </Link>
                </>
              )}
            </CardContent>
          </Card>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SpotlightSuccessPage;
